import styled from "styled-components";
import Carousel from "../../common/Carousel";
import { useContext } from "react";
import ProjectContext from "../../store/project-context";
import DemureBox from "./views/DemureBox";
import LyricsBox from "./views/LyricsBox";
import NovelcutBox from "./views/NovelcutBox";
import LebuBox from "./views/LebuBox";
import MangozBox from "./views/MangozBox";
import NovelpediaBox from "./views/NovelpediaBox";
import PortfolioBox from "./views/PortfolioBox";
import { media } from "../../lib/styles/media";
import NmixxfansBox from "./views/NmixxfansBox";
import MyLogBox from "./views/MyLogBox";

const Box = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  overflow: visible;
  gap: 2rem;
  box-sizing: border-box;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);

  ${media.phone`
    flex-direction: column;
    padding: 1rem;
  `}
`;

const LeftBox = styled.div`
  width: 500px;

  ${media.phone`
    width: 100%;
  `}
`;

const RightBox = styled.div`
  width: 580px;
  color: #fff;
  font-family: "S-CoreDream-3Light";

  ${media.phone`
    width: 100%;
  `}
`;

export default function ProjectViewBox() {
  const context = useContext(ProjectContext);
  const { project } = context;

  return (
    // 왼쪽 Carousel(사이트 이미지) + 페이지 이름
    // 오른쪽 프로젝트 설명 및 사용 스킬
    <Box>
      <LeftBox>
        <Carousel project={project} />
      </LeftBox>
      <RightBox>
        {project === "demure" ? (
          <DemureBox />
        ) : project === "lyrics" ? (
          <LyricsBox />
        ) : project === "novelcut" ? (
          <NovelcutBox />
        ) : project === "lebu" ? (
          <LebuBox />
        ) : project === "mangoz" ? (
          <MangozBox />
        ) : project === "novelpedia" ? (
          <NovelpediaBox />
        ) : project === "portfolio" ? (
          <PortfolioBox />
        ) : project === "nmixxfans" ? (
          <NmixxfansBox />
        ) : project === "mylog" ? (
          <MyLogBox />
        ) : (
          <></>
        )}
      </RightBox>
    </Box>
  );
}
